import { useState, React, useEffect } from "react";
import { usePrecandidateContext } from "../context/Context";
import { useTranslation } from "react-i18next";
import { PreCandidateService } from "../../../services/PreCandidate";
import "./styles.scss";
import { useGeneralContext } from "../../General/Context";
import SideDrawer from "../../../components/SideDrawer/SideDrawer";
import PreCandidateListFilters from "../../precandidate/grid/precandidateListFilter";

const FilterGrid = () => {
  const {
    searchObject,
    setSearchObject,
    pageNumber,
    pageSize,
    getPreCandidate
  } = usePrecandidateContext();
  const { userInformation } = useGeneralContext();
  const { t } = useTranslation();
  const formatAllow = { excel: 0, pdf: 1 };
  const [isFiltersOpen, setIsFilterOpen] = useState(false);

  function exportToExcel(format) {
    let fileName = "";
    if (format === formatAllow.excel) {
      fileName = `${t("Precandidate")}_${new Date().toLocaleDateString()}.xlsx`;
    } else {
      fileName = `${t("Precandidate")}_${new Date().toLocaleDateString()}.pdf`;
    }
    let _searchObject = { ...searchObject };
    if (_searchObject.businessAreas?.length > 0)
      _searchObject.businessAreas = _searchObject.businessAreas.map(
        (item) => item.id
      );
    PreCandidateService.exportToexcel(
      pageSize,
      pageNumber,
      fileName,
      format,
      _searchObject
    );
  }

  const clearFilters = () => {
    setIsFilterOpen(false);
    getPreCandidate({});
    setSearchObject({
      businessAreas: [],

      teamOnly: false
    });
  };

  function submitSearch() {
    let _searchObject = { ...searchObject };
    if (_searchObject.businessAreas?.length > 0)
      _searchObject.businessAreas = _searchObject.businessAreas.map(
        (item) => item.id
      );

    getPreCandidate(_searchObject);
    setIsFilterOpen(false);
  }

  return (
    <section className="precandidate-filters">
      <div className="text-end position-filter-button">
        <a href="#!" onClick={() => setIsFilterOpen(!isFiltersOpen)}>
          {t("Filters")}
        </a>
      </div>
      <SideDrawer
        isOpen={isFiltersOpen}
        direction="right"
        cancelBbutton={clearFilters}
        cancelButtonLabel={t("Clear")}
        submitButtonLabel={t("Search")}
        submitButton={submitSearch}
        onOverlayClick={() => setIsFilterOpen(false)}
      >
        <PreCandidateListFilters
          searchObject={searchObject}
          setSearchObject={setSearchObject}
        />
      </SideDrawer>
      {userInformation.permissions.Export_PreCand && (
        <div className="export-button">
          <button
            type="button"
            id="exportPreCandidates"
            className="app-button btn-second btn-md"
            aria-expanded="false"
            style={{ marginTop: "1px" }}
            onClick={() => {
              exportToExcel(formatAllow.excel);
            }}
          >
            {t("Export")}
          </button>
        </div>
      )}
    </section>
  );
};

export default FilterGrid;
